import { cva } from 'class-variance-authority';
export const durationPickerVariants = cva('relative flex rounded-surface bg-surface border border-border-subtle overflow-hidden items-center focus-within:ring-2 focus-within:ring-border-focus focus-within:ring-offset-0', {
    variants: {
        width: {
            full: 'w-full',
            fit: 'w-fit',
        },
    },
    defaultVariants: {
        width: 'full',
    },
});
export const durationPickerSectionVariants = cva('flex items-center px-stack', {
    variants: {
        width: {
            full: 'flex-1 min-w-0',
            fit: '',
        },
    },
    defaultVariants: {
        width: 'full',
    },
});
export const durationPickerInputVariants = cva('text-left min-w-8 min-h-12 text-body-sm text-fg-muted placeholder:text-body-sm placeholder:text-fg-disabled [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none border-0', {
    variants: {
        width: {
            full: 'flex-1',
            fit: 'w-8',
        },
    },
    defaultVariants: {
        width: 'full',
    },
});
